/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { observable } from 'mobx';

/**
 * Represents state of the sales line product.
 */
export class SalesLineState {
    @observable public isHidden?: boolean;

    public stateId: string;

    public constructor(stateId: string, isHidden?: boolean) {
        this.stateId = stateId;
        this.isHidden = isHidden;
    }
}
